import { Component, DestroyRef, Inject, ViewChild, inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ServicesService } from 'src/services/services.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';

export interface TicketData {
  category_id: any;
}

export interface TicketElement {
  srNo: string;
  category_id: any;
  code: string;
  amount: string;
  allowed_count: string;
  total_count: string;
  max_allowed: string;
  is_active: string;
  action: any;
}

@Component({
  selector: 'app-ticket-category',
  templateUrl: './ticket-category.component.html',
  styleUrls: ['./ticket-category.component.scss'],
  standalone: false
})
export class TicketCategoryComponent {
  displayedColumns: string[] = [
    'srNo',
    'category_id',
    'category',
    'total_amount',
    'color',
    'total_category_tickets',
    'max_allowed',
    'auto_assign',
    'is_active',
    'action',
  ];

  ELEMENT_DATA: TicketElement[] = [];
  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<TicketElement>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  ticket_result: any;
  event_id: any;

  constructor(private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) { }

  ngAfterViewInit() {
    this.event_id = sessionStorage.getItem('Event_ID');
    this.Get_TicketCode(this.event_id);
    this.dataSource.paginator = this.paginator;
  }

  AddTicket() {
    this.router.navigate(['/admin/Add Tickets Category']);
  }

  EditTicket(category_id: any) {
    console.log(category_id);

    const dialogRef = this.dialog.open(add_edit_ticket_category, {
      data: {
        category_id: category_id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_TicketCode(this.event_id);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  Get_TicketCode(event_id: any) {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.get_all_ticket_category(event_id).pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.ticket_result = data.data;

        // for (const item of this.ticket_result) {
        this.ELEMENT_DATA = this.ticket_result.map((item: any, index: number) => ({
          srNo: index + 1,
          auto_assign: item.auto_assign,
          category: item.category,
          category_id: item.category_id,
          color: item.color,
          total_category_tickets: item.total_category_tickets,
          max_allowed: item.max_allowed,
          total_amount: item.total_amount,
          is_active: item.is_active == 1 ? true : false,
          action: item.category_id
        })
        );
        // }

        this.dataSource = new MatTableDataSource<TicketElement>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
  }

  onCheckboxChange(user_id: any, element: any) {
    const isActiveValue = element.is_active ? 1 : 0;
    this.active_ticket_cat(element.category_id, isActiveValue);
  }

  active_ticket_cat(category_id: any, isActiveValue: any) {
    this.service.active_ticket_cat(category_id, isActiveValue).subscribe();
  }

  DeleteTicket(category_id: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete This Ticket?');
    if (buttonClicked === true) {
      this.service.delete_ticket_category(category_id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
        (data: any) => {
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.category_id !== category_id);
          this.dataSource.data = this.ELEMENT_DATA;
          this.toastr.success("Ticket Category Deleted Succesfully");
        });
    }
  }

  EditTicketCategory(category_id: any) {
    this.router.navigate(['/admin/Edit Tickets Category'], {
      queryParams: {
        category_id: category_id
      }
    })
  }

}



@Component({
  selector: 'add_edit_ticket_category',
  templateUrl: './add_edit_ticket_category.html',
  styleUrls: ['./ticket-category.component.scss'],
  standalone: false
})
export class add_edit_ticket_category {

  ScanningForm: FormGroup;
  private destoryRef = inject(DestroyRef);
  Ticket_data: any;
  result: any;
  hide = true;
  category_id: any
  auto_assign: any
  category: any
  color: string = '#ff0000'; // Default color

  total_category_tickets: any;
  total_amount: any;
  max_allowed: any;

  constructor(
    private member: FormBuilder,
    private service: ServicesService,
    private dialogRef: MatDialogRef<add_edit_ticket_category>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: TicketData
  ) {
    this.category_id = data['category_id'];

    // Initialize form group
    this.ScanningForm = this.member.group({
      category_id: this.category_id,
      auto_assign: new FormControl('', [Validators.required]),
      category: new FormControl('', [Validators.required]),
      color: new FormControl('', [Validators.required]),
      total_category_tickets: new FormControl('', [Validators.required]),
      total_amount: new FormControl('', [Validators.required]), // Apply conditional validators
      max_allowed: new FormControl('', [Validators.required]) // Apply conditional validators
    });
  }

  ngOnInit(): void {
    this.Get_Ticket_By_Id(this.category_id)
  }

  Get_Ticket_By_Id(category_id: any) {
    this.service.get_ticket_category_by_id(category_id).subscribe(
      (data: any) => {
        this.Ticket_data = data.data;
        this.category_id = this.Ticket_data[0].category_id;
        this.auto_assign = this.Ticket_data[0].auto_assign;
        this.category = this.Ticket_data[0].category;
        this.color = this.Ticket_data[0].color;
        this.total_category_tickets = this.Ticket_data[0].total_category_tickets;
        this.total_amount = this.Ticket_data[0].total_amount;
        this.max_allowed = this.Ticket_data[0].max_allowed;
      });
  }

  onFormSubmit() {
    console.log(this.ScanningForm.value);
    const formData = this.ScanningForm.value;
    const hasNonEmptyField = Object.values(formData).some(value => value !== null && value !== '');
    if (this.ScanningForm.valid && hasNonEmptyField) {
      console.log(this.ScanningForm.value);

      if (this.category_id) {
        this.service.edit_ticket_category(this.ScanningForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
          next: (val: any) => {
            if (val.flag == true) {
              this.toastr.success(val.msg);
              this.dialogRef.close(true);
            } else {
              this.toastr.error(val.msg);
            }
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      } else {
        this.service.add_ticket_category(this.ScanningForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({

          next: (val: any) => {
            if (val.flag == true) {
              this.toastr.success(val.msg);
              this.dialogRef.close(true);
            } else {
              this.toastr.error(val.msg);
            }
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      }
    } else {
      this.toastr.error("Please Fill Required Fields")
    }
  }
}
